<template>
  <perfect-scrollbar class="h-full">
    <div
      class="px-5 py-5 border-l border-r flex flex-col items-center justify-center h-full"
    >
      <img src="./../assets/imgs/logo.png" width="300px" class="mb-5" />
      <h1 class="text-3xl text-gray-800">RECURSOS HUMANOS</h1>
    </div>
  </perfect-scrollbar>
</template>

<script>
export default {
  name: "Dashboard",
};
</script>
